// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".q5LeS2i5DkQWwGF3WAAJ {\n\twidth: 100%;\n}\n", "",{"version":3,"sources":["webpack://./client/src/components/styles/FlagSelector.module.css"],"names":[],"mappings":"AAAA;CACC,WAAW;AACZ","sourcesContent":[".flagSelector {\n\twidth: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"flagSelector": "q5LeS2i5DkQWwGF3WAAJ"
};
export default ___CSS_LOADER_EXPORT___;
